// src/components/navLinks.js
import {
  HiOutlineHome,
  HiOutlineDocumentReport,
  HiOutlineOfficeBuilding,
  HiOutlineBell,
  HiOutlineBriefcase,
  HiOutlineCurrencyDollar,
  HiOutlineLogout,
  HiOutlineSupport,
  HiOutlineExclamationCircle,
  HiOutlineRefresh,
  HiOutlineDatabase,
  HiOutlineFire,
} from "react-icons/hi";

export const getNavLinks = (user, cooperative) => {

  let containsIDG = false;
  let containsIDA = false;
  let containsSBAG = false;
  let containsPRAR = false;
  let containsALRM = false;
  let containsRODZ = false;

  if (user?.managerId === "68f01b1777dc798cae180de1") {
    containsIDG = true;
  }

  if (user?.managerId === "6644ffbd8253c38a7dd4cc2e") {
    containsIDA = true;
  }

  cooperative?.forEach(coop => {
    if (!containsSBAG) {
      containsSBAG = coop?.equipments?.some(item => item.includes("SBAG"));
    }

    if (!containsPRAR) {
      containsPRAR = coop?.dryer?.length > 0;
    }

    if (!containsALRM) {
      containsALRM = coop?.otherEquipments?.some(item =>
        item?.serialNumber?.includes("ALRM")
      );
    }

    if (!containsRODZ) {
      containsRODZ = coop?.otherEquipments?.some(item =>
        item?.serialNumber?.includes("RODZ")
      );
    }
  });

  return [
    { path: "/home", label: "Home", icon: <HiOutlineHome size={18} />, permission: true },
    { path: "/dashboard-equipments", label: "Geneslab", icon: <HiOutlineDatabase size={18} />, permission: containsIDG },
    { path: "/dashboard-company", label: "Geral da Empresa", icon: <HiOutlineBriefcase size={18} />, permission: containsIDA },
    { path: "/relatorio", label: "Relatório", icon: <HiOutlineDocumentReport size={18} />, permission: user?.permissionSGU?.report?.read },
    { path: "/notification", label: "Notificações", icon: <HiOutlineExclamationCircle size={18} />, permission: user?.permissionSGU?.settings?.read },
    { path: "/units", label: "Unidades", icon: <HiOutlineOfficeBuilding size={18} />, permission: user?.permissionSGU?.units?.read },
    { path: "/alarm", label: "Alarmes", icon: <HiOutlineBell size={18} />, permission: containsALRM && user?.permissionSGU?.alarm?.read },
    { path: "/rotation", label: "Rodizio", icon: <HiOutlineRefresh size={18} />, permission: containsRODZ && user?.permissionSGU?.rodizio?.read },
    { path: "/silos-bag", label: "Silos Bag", icon: <HiOutlineDatabase size={18} />, permission: containsSBAG && user?.permissionSGU?.silosbag?.read },
    { path: "/dryer", label: "Secador", icon: <HiOutlineFire size={18} />, permission: containsPRAR && user?.permissionSGU?.dryer?.read },
    { path: "/empresa", label: "Dados da Empresa", icon: <HiOutlineBriefcase size={18} />, permission: user?.permissionSGU?.companyData?.read && !user?.hideSensitiveInfo },
    { path: "/mercadofinanceiro", label: "Mercado Financeiro", icon: <HiOutlineCurrencyDollar size={18} />, permission: true },
    { path: "/support-user", label: "Suporte", icon: <HiOutlineSupport size={18} />, permission: true },
    { path: "/logout", label: "Sair", icon: <HiOutlineLogout size={18} />, permission: true },
  ].filter(Boolean);
};
